var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"d-flex flex-row align-start pa-0 align-stretch event-container",attrs:{"fluid":""}},[_c('router-view',{staticClass:"container",attrs:{"tenant":_vm.tenant}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }